import React from "react"

// import { useRef } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useCallback } from 'react'

import { window, document } from 'browser-monads';
import { toast } from 'react-toastify'

const { localStorage } = window;


function BookmarkButton ({
    news_url,
    // news_title,
    // news_image,
    // news_author,
    // news_video,
    // news_is_media,
    // components_name_md5,
    // news_category,
    // news_excerpt,
    // news_date,
    // database_id
  }) {

  const [isPrefered, setIsPrefered] = useState(false);

  function adj_url(link) {

    let url = link;
    url = (url.endsWith( '/' )? url.slice(0, url.length -1) : url);
    // console.log(url)
    if (url.startsWith('/http')) {
      url = url.slice(1, url.length);
    }
    if (url.startsWith('http')) {
      url = new URL(url).pathname;
      // debugger;
    }
    return url;
  }

  function mag_set_preferred(url, title, img, author, video, is_media) {

    if (!url) url = window.location.pathname;
    url = adj_url(url)


    localStorage.setItem(url+'_prefered', Date.now())

    localStorage.setItem(
      url+'_prefered_info',
      JSON.stringify(
        {url:url, title:title, img:img, author:author, video:video, is_media:is_media, time: Date.now()}
      )
    );

    toast("Aggiunto agli articoli salvati",
    {
      hideProgressBar: true,
      autoClose: 2000,
      closeOnClick: true
    });
    setIsPrefered(true);
  }

  function mag_remove_preferred(url) {

    url = adj_url(url)


    localStorage.removeItem(url?url+'_prefered':window.location.pathname+'_prefered');
    localStorage.removeItem(url?url+'_prefered_info':window.location.pathname+'_prefered_info');

    // var toastId =
    toast('Rimosso dagli articoli salvati',{
      hideProgressBar: true,
      autoClose: 2000,
      closeOnClick: true }
    );

    setIsPrefered(false);
  }

  function play_button(){
    document.getElementById("click").play()
    //audio.play();
  }

  function is_prefered(link) {

    let url = adj_url(link)

    let _prefered = localStorage.getItem(url+'_prefered');
    if (_prefered && !isPrefered){
      setIsPrefered(true);
      return true;
    } else if (!_prefered && isPrefered) {
      setIsPrefered(false);
      return false;
    }
    return (_prefered) ? true : false;
  }

  function set_preferred(link, title, img, author, video, is_media) {
    let url = adj_url(link)

    mag_set_preferred(url, title, img, author, video, is_media);
    //is_prefered = true
    // reset_pref_color(link)
  }

  function unset_preferred(link) {
    let url = adj_url(link)

    mag_remove_preferred(url);
    //is_prefered = false
    // reset_pref_color(link)
  }

  function toggle_preferred(link, title, img, author, video, is_media) {

    play_button();
    let url = adj_url(link)

    // TODO: separate mixed part that show unread number in menu

    var unread = parseInt(localStorage.getItem("unread")?localStorage.getItem("unread"):0)
    if (unread < 0 ) unread = 0

    if (is_prefered(url)) {
      if (unread>0)
      unread--

      unset_preferred(url)
    }
    else {
      unread++

      set_preferred(url, title, img, author, video, is_media)
    }

    localStorage.setItem("unread", unread)
    if (unread > 0) {
      document.getElementById("unread_menu").style.display = "block"
      document.getElementById("unread_menu").innerHTML = unread
    } else {
      document.getElementById("unread_menu").style.display = "none"
    }
  }

  // function
  const check_prefered_icon = useCallback(
    (url) => {
      // if (!url) {
      //   return false;
      // }
      is_prefered(url);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )


  useEffect(() => {
    // console.log("useeffect", news_url);
    check_prefered_icon(news_url);

    return () => {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [news_url]);

  // useEffect(() => {
  //   // console.log("useeffect", news_url);
  //   check_prefered_icon(news_url);

  //   return () => {
  //   }
  // }, []);

  return <div
      role="button"
      tabIndex="0"
      id={"newmag_savearticle" + news_url}
      className="newmag_savearticle bookmark-button-comp"
      onClick={(event) => {
        toggle_preferred(
          window.news_url ? window.news_url : news_url,
          // window.news_title?window.news_title:news_title,
          // window.news_image?window.news_image:news_image,
          // window.news_author?window.news_author:news_author,
          // window.news_video?window.news_video:news_video,
          // window.news_is_media?window.news_is_media:news_is_media
        );
        event.preventDefault();
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter')
          toggle_preferred(
            window.news_url ? window.news_url : news_url,
            // window.news_title?window.news_title:news_title,
            // window.news_image?window.news_image:news_image,
            // window.news_author?window.news_author:news_author,
            // window.news_video?window.news_video:news_video,
            // window.news_is_media?window.news_is_media:news_is_media
          );
          event.preventDefault();
        }
      }
      style={{display: "inline-block"}}>
    <img
      // className={
      //   (isPrefered ? 'icon_prefered_set' : 'icon_prefered_unset')
      //   // " share_icons icon_prefered icon_prefered_"+window.location.pathname
      // }
      // id="prefered_share"
      alt="Set prefered"
      src={isPrefered ? "/img/on@2x.png" : "/img/off@2x.png"}
      style={{
        marginTop: "7px",
        width: "26px",
        height: "auto"
      }}
    />
  </div>
}

export default BookmarkButton;
